import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class RegionService {

    private readonly regionApiUrl = environment.apiEndpoint + 'region';
    private readonly comunaApiUrl = environment.apiEndpoint + 'comuna';

    constructor(private http: HttpClient) { }


    getRegiones(): Observable<any[]> {
        return this.http.get<any[]>(this.regionApiUrl, { withCredentials: true });
    }

    getRegionById(id: number | string): Observable<any> {
        return this.http.get<any>(`${this.regionApiUrl}/${id}`, { withCredentials: true });
    }

    getComunasByRegion(regionId: number | string): Observable<any[]> {
        return this.http.get<any[]>(`${this.comunaApiUrl}/region/${regionId}`, { withCredentials: true });
    }

}
